module.exports = function getResource(label, vars = []) {
    let resources = {
        newText: 'NOUVEAUTÉ'
    };
    return resources[label];
};
